(function () {
  'use strict';

  if (window.__volturaThemeBehavior20260717) return;
  window.__volturaThemeBehavior20260717 = true;

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }
    callback();
  }

  function drawerIsOpen(drawer) {
    return Boolean(drawer && (drawer.open || drawer.hasAttribute('open')));
  }

  function waitFor(milliseconds) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, milliseconds);
    });
  }

  function withTimeout(promise, milliseconds) {
    if (!promise || typeof promise.then !== 'function') return Promise.resolve();
    return Promise.race([promise.catch(function () {}), waitFor(milliseconds)]);
  }

  function setControls(drawer, expanded) {
    if (!drawer || !drawer.id) return;
    document.querySelectorAll('[aria-controls="' + drawer.id + '"]').forEach(function (control) {
      control.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  async function closeDrawer(drawer) {
    if (!drawer || !drawerIsOpen(drawer)) return;
    if (typeof drawer.hide === 'function') {
      await withTimeout(drawer.hide(), 700);
      return;
    }
    drawer.removeAttribute('open');
    drawer.hidden = true;
    drawer.setAttribute('inert', '');
    setControls(drawer, false);
  }

  async function openDrawer(drawer, trigger) {
    if (!drawer || drawerIsOpen(drawer)) return;
    if (typeof drawer.show === 'function') {
      await withTimeout(drawer.show(trigger || null), 700);
      return;
    }
    drawer.hidden = false;
    drawer.removeAttribute('inert');
    drawer.setAttribute('open', '');
    setControls(drawer, true);
  }

  function initExclusiveDrawers() {
    if (window.__volturaExclusiveDrawersReady) return;
    window.__volturaExclusiveDrawersReady = true;

    function drawers() {
      return {
        search: document.getElementById('SearchDrawer'),
        cart: document.getElementById('CartDrawer')
      };
    }

    async function switchTo(target, other, trigger) {
      if (!target || drawerIsOpen(target)) return;
      await closeDrawer(other);
      await openDrawer(target, trigger);
    }

    document.addEventListener('click', function (event) {
      var searchTrigger = event.target.closest('.search-drawer-button');
      var cartTrigger = event.target.closest('.cart-drawer-button');
      if (!searchTrigger && !cartTrigger) return;

      var current = drawers();
      if (searchTrigger && drawerIsOpen(current.cart) && !drawerIsOpen(current.search)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        switchTo(current.search, current.cart, searchTrigger);
        return;
      }

      if (cartTrigger && drawerIsOpen(current.search) && !drawerIsOpen(current.cart)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        switchTo(current.cart, current.search, cartTrigger);
      }
    }, true);

    function closeOtherWhenBothOpen(opened, other) {
      if (!opened || !other) return;
      opened.addEventListener('toggle', function () {
        if (drawerIsOpen(opened) && drawerIsOpen(other)) closeDrawer(other);
      });
    }

    var current = drawers();
    closeOtherWhenBothOpen(current.search, current.cart);
    closeOtherWhenBothOpen(current.cart, current.search);
  }

  function removeLegacyCollectionEntry() {
    document.querySelectorAll('.voltura-collection-entry').forEach(function (entry) {
      entry.remove();
    });
  }

  function removeLegacyPromotionSurfaces() {
    var selector = '#voltura-promo-overlay,.voltura-promo-overlay,.voltura-promo-modal';

    function remove() {
      document.querySelectorAll(selector).forEach(function (node) {
        node.remove();
      });
      document.documentElement.classList.remove('overflow-hidden');
      if (document.body) document.body.classList.remove('overflow-hidden');
    }

    remove();
    var observer = new MutationObserver(remove);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () {
      observer.disconnect();
    }, 10000);
  }

  ready(function () {
    removeLegacyPromotionSurfaces();
    removeLegacyCollectionEntry();
    initExclusiveDrawers();
  });
})();
